/**
 * Headers the middleware sets for server components to read.
 *
 * Kept out of `middleware.ts` so app code can import the constant without
 * pulling the middleware module (and its edge-runtime imports) into a Node
 * server bundle.
 */

/**
 * The request path. Server layouts have no `usePathname`, but the app shell
 * needs the path twice: to build `next=` when redirecting a signed-out
 * visitor, and to tell "onboarding unfinished, bounce them" from "already on
 * the onboarding page".
 */
export const PATHNAME_HEADER = 'x-uniap-pathname'

/**
 * next-intl's own locale cookie. It writes this on *every* request, echoing
 * whatever the URL said, so it cannot tell "the student chose this" from
 * "this is the URL they happened to open".
 */
export const NEXT_INTL_COOKIE = 'NEXT_LOCALE'

/**
 * The locale the student explicitly switched to in this browser.
 *
 * Separate from `NEXT_LOCALE` precisely because that one is not a signal of
 * intent. `users.locale` is the durable preference and follows them across
 * devices (FR-8); this cookie lets a fresh switch take effect before the
 * write lands, and stops the app shell's redirect from undoing it. It
 * expires after an hour, after which the account preference wins again
 * (T-I18N-01 step 3).
 */
export const LOCALE_SWITCH_COOKIE = 'uniap_locale'
export const LOCALE_SWITCH_MAX_AGE_SECONDS = 3600
